"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const selectors_1 = require("~/store/selectors");
const actions_1 = require("~/store/actions");
function BundleVersionWidget() {
    const { dispatchGetBundleVersion } = (0, redux_1.bindActionCreators)({
        dispatchGetBundleVersion: actions_1.fetchBundleVersion,
    }, (0, react_redux_1.useDispatch)());
    (0, react_1.useEffect)(() => {
        dispatchGetBundleVersion();
    }, []);
    const bundleVersion = (0, react_redux_1.useSelector)(selectors_1.selectBundleVersion);
    const versionText = (bundleVersion === null || bundleVersion === void 0 ? void 0 : bundleVersion.build) ? `Build: ${bundleVersion.build}` : `Version: ${bundleVersion.version}`;
    console.log(versionText);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.default = BundleVersionWidget;
